import { useApi } from './use-api-call';

export const useSearchUsersApi = () =>
    useApi<{ list: UserDTO[]; allowEdit: boolean }>('/manage-users/search-users');
export const useGetUsersApi = () =>
    useApi<{ user: UserDTO }>('/manage-users/save-user?userName={userName}');
export const useSaveUsersApi = () => useApi<{ user: UserDTO }>('/manage-users/save-user');
export const useDeleteUsersApi = () => useApi('/manage-users/delete-user?userName={userName}');

export const useSearchUserApi = () =>
    useApi<{
        users: UserDTO[];
        allowEdit: boolean;
    }>('/user/search-user');

export const useGetUserApi = () =>
    useApi<{ user: UserDTO; allowEdit: boolean }>('/user/get-user/{userName}');

export const useSaveUserApi = () => useApi<{ user: UserDTO }>('/user/save-user');

export const useDeleteUserApi = () => useApi('/user/delete-user/{userName}');

export interface UserDTO {
    userName?: string;
    firstName?: string;
    fatherName?: string;
    email?: string;
    displayName?: string;
    lastName?: string;
    passwordHash?: string;
    phoneNumber?: string;
    nationalCode?: string;
    postalCode?: string;
    phoneNumberConfirmed?: boolean;
    accessFailedCount?: number;
    lastAccessFailedDate?: Date;
    addressSerial?: number;
    certificate?: string;
    defaultLanguage?: string;
    isServiceUser?: boolean;
    isDeleted?: boolean;
    isDisabled?: boolean;
    uniqueId?: string;
    targetCustormerId?: number;
    imageAttachmentId?: number;
    lastUpdate?: Date;
    createdAt?: Date;
}
